//Style
import '../scss/style.scss';

//Javascript
import 'bootstrap';
//import jQuery from "jquery";
import AOS from 'aos';

function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}
var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;
var $window = jQuery(window);
var lastScrollTop = $window.scrollTop();

jQuery(document).ready(function ($) {});

AOS.init();